import styled from 'styled-components';

export const StatiscsStyled = styled.div``;
